/**
 * Finalish pages intentionally coalesce query strings, hashes and trailing
 * slashes. Keep this function aligned with the backend page resolver.
 */
export function canonicalPageKey(
  value: string | URL = globalThis.location?.href ?? 'http://localhost/',
): string {
  const base = globalThis.location?.href ?? 'http://localhost/';
  const url = value instanceof URL ? value : new URL(value, base);
  return `${url.origin}${normalizePathname(url.pathname)}`;
}

export function routeKeyMatchesPage(
  routeKey: string | null | undefined,
  pageKey: string = canonicalPageKey(),
): boolean {
  if (!routeKey) return true;
  try {
    return canonicalPageKey(routeKey) === canonicalPageKey(pageKey);
  } catch {
    return false;
  }
}

/**
 * A route can render materially different authenticated and unauthenticated
 * screens without changing its URL. Keep a small, stable view fingerprint in
 * the anchor so feedback from those screens cannot bleed into one another.
 */
export function canonicalDocumentTitle(
  value: string = globalThis.document?.title ?? '',
): string {
  return value
    .replace(/^\(\d+\)\s*/, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase()
    .slice(0, 160);
}

function normalizePathname(value: string): string {
  if (!value || value === '/') return '/';
  const normalized = value.replace(/\/+$/, '');
  return normalized || '/';
}
